module.exports = __webpack_public_path__ + "static/media/caret-circle-right.c563de92.svg";